enum WorkspaceProjectMetricMeasurementPointCreation {
  'Add difference' = 'Add difference',
  'Add total' = 'Add total',
}

export default WorkspaceProjectMetricMeasurementPointCreation
